import { useEffect, useRef } from 'react'

// hook observes changes in the element's content or attributes, and the `callback` function will be called whenever such changes occur.
const useMutationObserver = callback => {
  const observerRef = useRef(null)

  useEffect(() => {
    observerRef.current = new MutationObserver(callback)

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect()
        observerRef.current = null
      }
    }
  }, [callback])

  return observerRef
}
export default useMutationObserver
